import http from 'utils/http';
import {
  getCouponsUrl,
  getCouponUrl,
  createCouponUrl,
  updateCouponUrl,
  deleteCouponUrl,
  getCouponCodeUrl
} from './apiUrls';
import { CouponResponse, Coupon, CreateCouponRequest, UpdateCouponRequest, CouponCodeResponse } from './types';

export function getCoupons(params?: Record<string, any>): Promise<CouponResponse> {
  return http.get(getCouponsUrl(), params);
}

export function getCouponCode(params?: Record<string, any>): Promise<CouponCodeResponse> {
  return http.get(getCouponCodeUrl(), params);
}

export function getCoupon(couponId: string): Promise<Coupon> {
  return http.get(getCouponUrl(couponId));
}

export function createCoupon(data: CreateCouponRequest): Promise<Coupon> {
  return http.post(createCouponUrl(), data);
}

export function updateCoupon(data: UpdateCouponRequest): Promise<Coupon> {
  return http.put(updateCouponUrl(data.id), data);
}

export function archiveCoupon(data: { id: number; status: 'active' | 'archived' }): Promise<Coupon> {
  return http.patch(updateCouponUrl(data.id), data);
}

export function deleteCoupon(couponId: number): Promise<void> {
  return http.delete(deleteCouponUrl(couponId));
}
